<template>
  <div class="wrapper" v-if="isdialogFormVisible">
    <el-dialog
      :title="dialogtitle"
      :visible.sync="dialogFormVisible"
      @close="dialogclose"
      destroy-on-close
      :width="width"
      :modal="false"
    >
    <div class="center" :style="{height:heights}">
        <div class="pics_group">
            <el-carousel :interval="4000" arrow="always">
                <el-carousel-item v-for="(item,index) in pics" :key="index">
                        <el-image style="width: 100%; height: 100%" fit="contain" :src="item.url" :preview-src-list="srcList"></el-image>
                </el-carousel-item>
            </el-carousel>
        </div>
         <div class="qiehuan">
            <el-link icon="el-icon-user-solid" style="color:skyblue;" @click="qiehuanClick(0)">基础信息</el-link>
            <el-link style="color:skyblue;" @click="qiehuanClick(1)"><i class="el-icon-sunrise-1"></i>配件信息</el-link>
            <el-link style="color:skyblue;" @click="qiehuanClick(2)"><i class="el-icon-position"></i>地理位置 </el-link>
            <el-link style="color:skyblue;" @click="qiehuanClick(3)"><i class="el-icon-monitor"></i>设备台账</el-link>


        </div>
        <div class='content_detail'>
            <div class="detai_box">
                <el-row :gutter="20">
                    <el-col v-show="lodeg_isbool" :span="10" v-for="(item,index) in detailinfo.info" :key="item.key+item.value"><span class='dian'></span>{{item.key}}：{{item.value}}</el-col>
                    <el-col v-show="!lodeg_isbool" :span="10" v-for="(item,index) in detailinfo.peri" :key="item.key+item.value"><span class='dian'></span>{{item.key}}：{{item.value}}</el-col>
                </el-row>
    
            </div>

        </div>
         <div class="center_right">
             <el-row :gutter="1" >
                    <el-col :span="24" v-for="(item,index) in probes" :key="index">
                        <img class="center_right_imglog" :src="require('../../../static/img/alarm_redg.png')" />
                        <!-- <span class="number">编号：{{item.num}}</span> -->
                        <span class="spantitle">{{item.name}}：{{item.val}}</span>
                    </el-col>
                </el-row>
         </div>
    </div>
    </el-dialog> 
  </div>
</template>
<script>
import dataUrl from "../../libs/js/interfaceAddress.js";

export default {
  components: {
  },
  props: {
    isdialogFormVisible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String
    },
    ishiddeCallBack: {
      type: Function
    },
    width: {
      type: String,
      default: '200px'
    },
    height: {
      type: String,
      default: '200px'
    },
    dialogInfoData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dialogFormVisible: false,
      dialogtitle:'',
      heights: '500px',
      pics:[],
      detailinfo:{},
      probes:[],
      srcList: [],
      lodeg_isbool:true,
    }
  },
  watch: {
    isdialogFormVisible: {
      handler: function(newVal) {
        this.dialogFormVisible = newVal
        if(newVal){
            this.netWorkdata()
        }
       
      }
    }
  },
  computed: {},
  methods: {
      dialogclose(){
         this.$props.ishiddeCallBack();
      },
      netWorkdata(){
          this.srcList= []
          this.pics = []
          this.detailinfo ={}
          this.probes = []
          this.$http.get (dataUrl.interfaceAddress.getDevdetails, {params: {deviceId:this.dialogInfoData.deviceId}}).then (res => {
            this.pics = res.data.body.pic
            this.detailinfo = res.data.body
            this.probes = res.data.body.data
            this.dialogtitle = res.data.body.title
            this.pics.filter((item, i) => {
                  this.srcList.push(item.url)
            })
            console.log("商业报警器数据回调=--=-=-==-", JSON.stringify(this.detailinfo));
          })
         .catch((err) => {
            console.log(err);
         });
      },
       mappush(){
                 
            var marker = new AMap.Marker({
                position:this.detailinfo.position,
              
            })
               marker.markOnAMAP({
                        name:this.dialogInfoData.title,  //地理位置名称
                        position: marker.getPosition()
               })
      },
      qiehuanClick(tag){
                console.log('数据触发内容-=-=-=-'+tag)
               
                switch (tag) {
                    case 0:
                        this.lodeg_isbool = true                       
                        break;
                    case 1:
                        this.lodeg_isbool = false                      
                        break;
                    case 2:
                        this.mappush()
                        break;
                    case 3:
                        this.$bus.$emit("push_device_tabs")
                        break;
                        
                
                    default:
                        break;
                }
            }
  },
  created() {
  },
  mounted() {
  }
}
</script>
<style lang="less" scoped>
 .qiehuan{
            position: relative;
            top: 65%;
       
        }
.pics_group{
    padding: 10px 0 0 0;
    position: absolute;
    width: 71%;
    height: 52%;
    top: 10%;
    background-color: rgba(82, 231, 241, 0.3);
}
.el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  
  .bg-purple {
    background: #d3dce6;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 30px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
  .center_right{
      position: absolute;
      right: 1%;
      top: 8%;
      background-color:rgba(0, 0, 0, 0.3);
      width: 25%;
      height: 90%;
      padding: 0px 10px 0px 5px;
      overflow:auto;
      .el-col{
          margin-top: 10%;
          
      }
      .number{
         position: relative;
         color: greenyellow;
         top: -10px;
         left: 5%;
      }
      .center_right_imglog{
        width:25px;
        height:25px;
        float: left;
        position: relative;

      }
      .spantitle{
          color: wheat;
          margin-left: 5px;
          
      }
  }
 
.content_detail {
            width: 100%;
            height: 26%;
            color: #ffffff;
            font-size: 12px;
            top: 70%;
            background: url(https://gas95.oss-cn-beijing.aliyuncs.com/monitor/static/img/detail_bottom.png) no-repeat;
            background-size: 100% 100%;
            background-size: contain;
            position: relative;

            .detai_box {
                padding: 20px 0 0 10px;
                position: absolute;
                width: 75%;
                .el-col{
                        margin-top:1.5%;
                        margin-left:2%;

                }

                .dian {
                    display: inline-block;
                    width: 6px;
                    height: 6px;
                    border-radius: 50%;
                    background: #08d320;
                    margin-right: 10px;
                    
                }
            }

        }
& /deep/   .el-carousel__container {
    position: relative;
    width: 97%;
    left: 10px;
    right: 10px;
    }
& /deep/  .el-dialog__title{
        color: rgb(146, 211, 241);
        
        text-align: center;

  }
& /deep/  .el-dialog__header{
      background: url("https://gas95.oss-cn-beijing.aliyuncs.com/monitor/static/img/bg-min.png") no-repeat;
  }
& /deep/  .el-dialog__body {
    padding: 30px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
    background: url("https://gas95.oss-cn-beijing.aliyuncs.com/monitor/static/img/bg-min.png") no-repeat;
    background-size: 100% 100%;
}

& /deep/  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }
  
& /deep/  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  
& /deep/  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
& /deep/  .el-dialog__wrapper {
    background-color:rgba(0,0,0,0.5);
}
& /deep/  .el-dialog__header {
    padding: 20px 20px 10px;
    text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/components/dialog/dialog_details.vue